export const GoogleMapApiConfig = 'AIzaSyC8rm3gcmBJn9rCiFPxiU9oNwjNlTVipX4';